import React, { Component, PropTypes } from 'react';
import { LoadingIndicator } from 'common/components/preloader';
import EntryGallery from 'common/components/entry_gallery';
import { getDefaultViewType } from 'common/components/entry_gallery/view_type_selector';
import { getDefaultGrouping } from 'common/components/entry_gallery/grouping_selector';
import Pager from 'common/pager/containers';
import { ENTRIES_RESOURCE_NAME } from 'entries/constants';
import { hasAPIQueryStringChanged } from 'common/utils';
import Controls from 'entries/containers/controls';
import Awards from 'entries/containers/awards';
import PendingOffers from 'entries/containers/pending_offers';
import DeleteModal from 'entries/containers/delete_modal';
import TipModal from 'entries/containers/tip_modal';
import OfferModal from 'entries/containers/offer_modal';
import RemoveCreativeModal from 'entries/containers/remove_creative_modal';
import ReinstateModal from 'entries/containers/reinstate_modal';
import AwardModal from 'entries/containers/award_modal';
import WinnerEntryBanner from 'entries/containers/winner_banner';
import LoginRequired from 'project/containers/login_required';
import ParticipationPermsCallout from 'project/containers/participation_perms_callout';
import PackageTipped from 'entries/containers/package_tipped';
import Meta from 'project/containers/meta';
import AppliedFilters from 'entries/containers/applied_filters';

export default class Entries extends Component {
  componentDidMount() {
    const { fetch, setViewType, setGrouping, project, location, grouped, viewType } = this.props;

    if (location.query.keep_view_type !== "true" || viewType === undefined) {
      setViewType(getDefaultViewType(project.entry_type));
    }

    if (location.query.keep_grouping !== "true" || grouped === undefined) {
      setGrouping(getDefaultGrouping());
    }

    fetch();
  }

  componentDidUpdate(prevProps) {
    /* re-fetch resource if filter/sorting/search/etc query parameters have changed */
    if (hasAPIQueryStringChanged(ENTRIES_RESOURCE_NAME, prevProps, this.props)) {
      this.props.fetch();
    }
  }

  componentWillUnmount() {
    this.props.clear();
  }

  renderContent() {
    const {
      project, entries, viewType, grouped, isFetching, showWinnerBanner, loginRequired,
      galleryClosed
    } = this.props;

    if (galleryClosed) {
      return (
        <div className="row">
          <div className="small-16 columns">
            <h2>This project has a closed gallery.</h2>
            <p>
              Only the client can see all entries. Participants can see only their own entries.
            </p>
          </div>
        </div>
      );
    }

    if (loginRequired) {
      return (
        <div className="row">
          <div className="small-16 columns">
            <LoginRequired />
          </div>
        </div>
      );
    }

    return (
      <div>
        { showWinnerBanner && <WinnerEntryBanner /> }

        <ParticipationPermsCallout />

        <PendingOffers />

        <PackageTipped />

        <div className="row">
          <div className="small-16 columns">
            <div className="row">
              { isFetching?
              <div className="columns small-16 large-12">
                <LoadingIndicator />
              </div> :
              <div className="columns small-16 large-12">
                <Awards />
                <AppliedFilters resourceName={ENTRIES_RESOURCE_NAME} />
                <EntryGallery entryType={project.entry_type} viewType={viewType}
                  itemVariation="projectEntries" items={entries} grouped={grouped} />
                <Pager resourceName={ENTRIES_RESOURCE_NAME} />
              </div> }
              <div className="columns small-16 large-4">
                <Controls />
              </div>
            </div>

            <DeleteModal />
            <TipModal />
            <OfferModal />
            <RemoveCreativeModal atEntries={true} />
            <ReinstateModal />
            <AwardModal />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { atYourEntries } = this.props;

    return (
      <div>
        <Meta title={atYourEntries? "Your entries" : "Entries"}
          customMeta={[{ name: 'robots', content: 'noindex,nofollow' }]} />
        { this.renderContent() }
      </div>
    )
  }
}

Entries.propTypes = {
  project: PropTypes.object.isRequired,
  entries: PropTypes.array.isRequired,
  viewType: PropTypes.string,
  grouped: PropTypes.bool,
  fetch: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  setViewType: PropTypes.func.isRequired,
  setGrouping: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  showWinnerBanner: PropTypes.bool.isRequired,
  loginRequired: PropTypes.bool.isRequired,
  galleryClosed: PropTypes.bool.isRequired,
  atYourEntries: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./entries/components/index.jsx